module.exports = __webpack_public_path__ + "static/media/featured-star.4c3cf54b.svg";